import PropTypes from 'prop-types';
import { memo } from 'react';
import TeacherStatsHeader from './TeacherStatsHeader.js';
import TeacherStatsIntro from './TeacherStatsIntro.js';
import TeacherStatsBanner from './TeacherStatsBanner.js';
import TeacherStatsDonorChooseHistory from './TeacherStatsDonorsChooseHistory.js';
import TeacherStatsLiveProjects from './TeacherStatsLiveProjects.js';
import TeacherStatsReferredTeachers from './TeacherStatsReferredTeachers.js';
import TeacherStatsDonors from './TeacherStatsDonors.js';
import TeacherStatsMoneyRaised from './TeacherStatsMoneyRaised.js';
import TeacherStatsFooter from './TeacherStatsFooter.js';
import {
    SelfStarter,
    GotMail,
    BigThanker,
    FirstProject,
    FifthProject,
    TenthProject,
    TYP,
    Referred,
    BTS,
    Restock,
} from './TeacherStatsAchievements.js';

let TeacherStatsController = function ({
    data,
    isTeacher,
    teacherName,
    teacherProfilePhotoURL,
    schoolName,
    schoolCityAndState,
    teacherPossessiveScreenName,
    liveProposals,
    teacherProfileUrl,
    schoolURL,
    schoolState,
}) {
    const {
        numMonthsActive, lifetimeFullyFundedProjects, numProjectsCurrentlyLive,
        numLifetimeDonors, hasCreatedFirstProject, hasUsedSendFriend,
        numSentProjectMessage, numStudentTYPCompleted, numTeachersReferred, postedDuringFY23NewYear,
        lifetimePaymentAmountReceived, thisYearPaymentAmountReceived, lastYearPaymentAmountReceived, postedDuringFY23BackToSchool,
    } = data;
    return (
        <div className="teacherStatsWrapper">
            <TeacherStatsHeader isTeacher={isTeacher} teacherPossessiveScreenName={teacherPossessiveScreenName}/>

            <main className="teacherStatsMain">
                <TeacherStatsIntro isTeacher={isTeacher} schoolURL={schoolURL} schoolCityAndState={schoolCityAndState}
                    schoolName={schoolName} teacherName={teacherName} teacherProfilePhotoURL={teacherProfilePhotoURL}
                    lifetimeFullyFundedProjects={lifetimeFullyFundedProjects} />
                <TeacherStatsBanner isTeacher={isTeacher} teacherName={teacherName}/>
                <TeacherStatsDonorChooseHistory lifetimeFullyFundedProjects={lifetimeFullyFundedProjects} numMonthsActive={numMonthsActive} />
                <TeacherStatsLiveProjects liveProposals={liveProposals} isTeacher={isTeacher} numProjectsCurrentlyLive={numProjectsCurrentlyLive} />
                <TeacherStatsReferredTeachers isTeacher={isTeacher} numTeachersReferred={numTeachersReferred} />
                <TeacherStatsDonors teacherPossessiveScreenName={teacherPossessiveScreenName} isTeacher={isTeacher} numLifetimeDonors={numLifetimeDonors} />
                <TeacherStatsMoneyRaised thisYearPaymentAmountReceived={thisYearPaymentAmountReceived}
                    lastYearPaymentAmountReceived={lastYearPaymentAmountReceived}
                    lifetimePaymentAmountReceived={lifetimePaymentAmountReceived}
                    isTeacher={isTeacher}/>

                <div className="achievementsWrapper">
                    <h3>Achievements</h3>

                    <div className='achievementsBadges'>
                        <SelfStarter hasCreatedFirstProject={hasCreatedFirstProject}/>
                        <Restock postedDuringFY23NewYear={postedDuringFY23NewYear}/>
                        <BTS postedDuringFY23BackToSchool={postedDuringFY23BackToSchool}/>
                        <BigThanker numSentProjectMessage={numSentProjectMessage}/>
                        <FirstProject lifetimeFullyFundedProjects={lifetimeFullyFundedProjects}/>
                        <FifthProject lifetimeFullyFundedProjects={lifetimeFullyFundedProjects}/>
                        <TenthProject lifetimeFullyFundedProjects={lifetimeFullyFundedProjects}/>
                        <TYP numStudentTYPCompleted={numStudentTYPCompleted}/>
                        <Referred numTeachersReferred={numTeachersReferred}/>
                        <GotMail hasUsedSendFriend={hasUsedSendFriend}/>
                    </div>

                </div>
            </main>

            <TeacherStatsFooter isTeacher={isTeacher} teacherName={teacherName} teacherPossessiveScreenName={teacherPossessiveScreenName} teacherProfileUrl={teacherProfileUrl}/>

        </div>
    );
};

TeacherStatsController.propTypes = {
    data: PropTypes.object,
    isTeacher: PropTypes.bool.isRequired,
    teacherName: PropTypes.string,
    teacherProfilePhotoURL: PropTypes.string,
    teacherProfileUrl: PropTypes.string,
    schoolName: PropTypes.string,
    schoolCityAndState: PropTypes.string,
    schoolURL: PropTypes.string,
    teacherPossessiveScreenName: PropTypes.string,
    liveProposals: PropTypes.array,
    schoolState: PropTypes.string,
};

TeacherStatsController = memo(TeacherStatsController);
export default TeacherStatsController;
